import React, { useRef } from 'react';
import { ContentSectionDetail } from '../ContentSection';
import { Carousel } from '@mantine/carousel';
import Autoplay from 'embla-carousel-autoplay';
import LeaderWisdomItem from './LeaderWisdomItem';
import classes from '../../banner/styles.module.scss';

interface MultipleLeaderWisdomProps {
  data: ContentSectionDetail[];
  title: string;
}

const MultipleLeaderWisdom: React.FC<MultipleLeaderWisdomProps> = ({
  data,
  title
}) => {
  const autoplay = useRef(Autoplay({ delay: 4000 }));
  return (
    <Carousel
      loop
      withIndicators
      classNames={classes}
      plugins={[autoplay.current]}
      onMouseEnter={autoplay.current.stop}
      onMouseLeave={autoplay.current.reset}
      mb={32}
      className="container-leader-wisdom-section__carousel"
    >
      {data.map((item: ContentSectionDetail, index: number) => {
        return (
          <Carousel.Slide key={index}>
            <LeaderWisdomItem {...item} title={title} />
          </Carousel.Slide>
        );
      })}
    </Carousel>
  );
};

export default MultipleLeaderWisdom;
